"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetSubscriptions = void 0;
var _auth = require("@ori/auth");
var _checkoutUtils = require("@ori/checkout-utils");
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _presentationHttp = require("@ori/presentation-http");
var _shoppingContext = require("@ori/shopping-context");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _constants = require("../constants");
const useGetSubscriptions = isEnabled => {
  const {
    shoppingContext: {
      customerId = _auth.NOT_LOGGED_IN_USER_ID
    } = {}
  } = (0, _shoppingContext.useShoppingContext)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language: lang
  } = (0, _i18n.useTranslationsWithNamespaces)();
  const sessionId = (0, _shoppingContext.useSessionId)();
  const {
    atpClusterId,
    customerTypeId,
    visitorSegment
  } = (0, _presentationHttp.useUserSegmentationData)();
  const subscriptionsResponse = (0, _globalApiClientReact.useGetShoppingSessionPersonalSubscriptions)(sessionId, {
    statusFilter: _globalApiClientReact.GetShoppingSessionPersonalSubscriptionsStatusFilter.Pending
  }, {
    [_checkoutUtils.TENANT_CONTEXT]: tenant
  }, {
    swr: {
      ..._checkoutUtils.errorHandlingSwrOptions,
      enabled: customerId !== _auth.NOT_LOGGED_IN_USER_ID && isEnabled
    }
  });
  const subscriptionsItemCodes = subscriptionsResponse.data?.collection.map(({
    itemCode
  }) => itemCode ?? '') ?? [];
  const productsResponse = (0, _staticApiClientReact.useGetTenantApplicationsProductBox)(tenant, {
    productCodes: subscriptionsItemCodes,
    lang,
    atpClusterId: atpClusterId ?? undefined,
    customerTypeId: customerTypeId ?? undefined,
    visitorSegment: visitorSegment ?? undefined
  }, {
    swr: {
      ..._checkoutUtils.errorHandlingSwrOptions,
      enabled: Boolean(subscriptionsResponse.data?.collection.length)
    }
  });
  const staticSubscriptionsResponse = (0, _globalApiClientReact.useGetPersonalSubscriptions)({
    customerId
  }, {
    [_checkoutUtils.TENANT_CONTEXT]: tenant
  }, {
    swr: {
      ..._checkoutUtils.errorHandlingSwrOptions,
      enabled: Boolean(subscriptionsResponse.data?.collection.length) && Boolean(productsResponse.data?.data?.products.length)
    }
  });
  const subscriptions = (0, _react.useMemo)(() => subscriptionsResponse.data?.collection.map(subscription => ({
    ...subscription,
    nextShipment: staticSubscriptionsResponse.data?.collection.find(staticSubscription => staticSubscription.personalSubscriptionId === subscription.personalSubscriptionId)?.nextShipment,
    product: productsResponse.data?.data?.products.find(product => product.productCode === subscription.itemCode)
  })) ?? [], [productsResponse.data?.data?.products, staticSubscriptionsResponse.data?.collection, subscriptionsResponse.data?.collection]);
  const subscriptionItemsCount = subscriptions.length;
  const isMoreDesktop = subscriptionItemsCount - _constants.MAX_DESKTOP_ITEMS > 0;
  const isMoreMobile = subscriptionItemsCount - _constants.MAX_MOBILE_ITEMS > 0;
  const isValidating = subscriptionsResponse.isValidating || productsResponse.isValidating || staticSubscriptionsResponse.isValidating;
  const error = Boolean(subscriptionsResponse.error) || Boolean(productsResponse.error) || Boolean(staticSubscriptionsResponse.error);
  return {
    isMoreDesktop,
    isMoreMobile,
    subscriptions,
    subscriptionItemsCount,
    isValidating,
    error,
    mutateSubscriptions: subscriptionsResponse.mutate
  };
};
exports.useGetSubscriptions = useGetSubscriptions;